import React from 'react';
import { Link } from 'react-router-dom';

function Contact() {
  return (
    <>
      <div class="page-banner-area item-bg3">
        <div class="container">
          <div class="page-banner-content">
            <h2>Contact</h2>
            <ul>
              <li>
                <Link to={"/"}>Home</Link>
              </li>
              <li>Contact</li>
            </ul>
          </div>
        </div>
      </div>
      <section class="contact-info-area pt-100 pb-70">
        <div class="container">
          <div class="row">
            <div class="col-lg-4 col-sm-6">
              <div class="contact-info-box">
                <div class="icon">
                  <i class="flaticon-office"></i>
                </div>

                <h3>Office</h3>
                <p>PARGATI ONLINE SERVICE PRIVATE LIMITED SCO 832, 2nd Floor, NAC Manimajra, Chandigarh 160101</p>
              </div>
            </div>

            <div class="col-lg-4 col-sm-6">
              <div class="contact-info-box">
                <div class="icon">
                  <i class="flaticon-contact"></i>
                </div>

                <h3>Contact</h3>
                <p><a href="tel:01724049681">01724049681</a></p>
                <p><a href="mailto:support@pargationline.com"><span>support@pargationline.com</span></a></p>
              </div>
            </div>

            <div class="col-lg-4 col-sm-6">
              <div class="contact-info-box">
                <div class="icon">
                  <i class="flaticon-time"></i>
                </div>

                <h3>Open hours</h3>
                <p>Mon–Sat: 10 AM - 6 PM</p>
                <p>Sunday: Closed</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="contact-area ptb-100">
        <div class="container">
          <div class="section-title">
            <h2>Contact Us for Any Inquiries</h2>
            <p>Please feel free to contact us with any questions or concerns. Our team is available to provide assistance and respond to your inquiries promptly.</p>
          </div>
          <div class="contact-form">
            <form id="contactForm">
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <label>Full name</label>

                    <input type="text" name="name" id="name" class="form-control" required data-error="Please enter your name" placeholder="Full name" />
                    <div class="help-block with-errors"></div>
                  </div>
                </div>

                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <label>Email</label>

                    <input type="email" name="email" id="email" class="form-control" required data-error="Please enter your email" placeholder="Email" />
                    <div class="help-block with-errors"></div>
                  </div>
                </div>

                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <label>Phone</label>

                    <input type="text" name="phone_number" id="phone_number" required data-error="Please enter your number" class="form-control" placeholder="Phone" />
                    <div class="help-block with-errors"></div>
                  </div>
                </div>

                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <label>Subject</label>

                    <input type="text" name="msg_subject" id="msg_subject" class="form-control" required data-error="Please enter your subject" placeholder="Subject" />
                    <div class="help-block with-errors"></div>
                  </div>
                </div>

                <div class="col-lg-12 col-md-12">
                  <div class="form-group">
                    <label>Your message</label>

                    <textarea name="message" class="form-control" id="message" cols="30" rows="5" required data-error="Write your message" placeholder="Message here."></textarea>
                    <div class="help-block with-errors"></div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="checkme" />
                    <label class="form-check-label" for="checkme">
                      Accept <Link to="/termAndConditions" target="_blank">Terms of Services</Link> and <Link to="/privacyPolicy" target="_blank">Privacy Policy.</Link>
                    </label>
                  </div>
                </div>

                <div class="col-lg-12 col-md-12">
                  <button type="submit" class="default-btn">Send Message</button>
                  <div id="msgSubmit" class="h3 text-center hidden"></div>
                  <div class="clearfix"></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
      <div id="map">
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d6860.611057917548!2d76.84206764415342!3d30.709810075424905!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1766141656726!5m2!1sen!2sin"></iframe>
      </div>
    </>
  );
}

export default Contact;
